var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNearLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0742 3.55888C13.5116 1.29732 11.0351 0 8.28021 0C5.5253 0 3.04879 1.29732 1.48618 3.55888C-0.0687555 5.809 -0.427796 8.65771 0.523836 11.1745C0.778374 11.8618 1.18299 12.5296 1.72357 13.1553L7.73535 20.2168C7.87132 20.3766 8.07053 20.4687 8.28021 20.4687C8.48989 20.4687 8.6891 20.3766 8.82507 20.2168L14.8352 13.1572C15.3781 12.5279 15.7822 11.8609 16.0347 11.1791C16.9882 8.65771 16.6292 5.809 15.0742 3.55888ZM14.6944 10.6778C14.4998 11.2039 14.182 11.7239 13.7505 12.2242C13.7493 12.2254 13.7481 12.2266 13.7471 12.228L8.28021 18.6492L2.80997 12.224C2.37865 11.7242 2.06086 11.2041 1.86429 10.6731C1.07729 8.59162 1.37596 6.23628 2.66349 4.37287C3.95505 2.5035 6.00239 1.43137 8.28021 1.43137C10.558 1.43137 12.6051 2.50346 13.8967 4.37287C15.1845 6.23628 15.4834 8.59162 14.6944 10.6778Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28128 4.24609C6.07147 4.24609 4.27344 6.0439 4.27344 8.25396C4.27344 10.464 6.07123 12.2618 8.28128 12.2618C10.4913 12.2618 12.2891 10.464 12.2891 8.25396C12.2891 6.04414 10.4911 4.24609 8.28128 4.24609ZM8.28128 10.8304C6.86063 10.8304 5.7048 9.67458 5.7048 8.25393C5.7048 6.83327 6.86063 5.67743 8.28128 5.67743C9.70193 5.67743 10.8578 6.83327 10.8578 8.25393C10.8578 9.67458 9.70193 10.8304 8.28128 10.8304Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNearLarge);
export default __webpack_public_path__ + "static/media/search-near-large.f8b1415f05887c3c114828b8dcdff2d7.svg";
export { ForwardRef as ReactComponent };